const CampaignState = {
  campaigns: {
    email: {data: []},
    sms: {data: []},
    push: {data: []},
  },
};

export default CampaignState;
